import React, { Component ,Fragment} from 'react';
import Breadcrumb from "../../common/breadcrumb"
import queryString from "query-string";
import { putToast, getObject, updateObject, packData, listItems, generateTournament, generateWarning, reviseTournamentPage } from "../../api";
import { AvField, AvForm } from 'availity-reactstrap-validation';
import Editor from "../../common/quillEditor";
import { FlowDataEntry } from '../../common/flowDataEntry'
import DateTimePicker from 'react-datetime-picker';
import JSONInput from 'react-json-editor-ajrm';
import locale    from 'react-json-editor-ajrm/locale/en';

export class TournamentPageEdit extends Component {
    constructor(props) {
        super(props)
        const value=queryString.parse(this.props.location.search);
        this.handleContentChange = this.handleContentChange.bind(this);
        this.handleHookChange = this.handleHookChange.bind(this);

        this.state = {
            loading: true,
            menuJson: "",
            roomJson: "",
            eventJson: "",
            roundJson: "",
            pid: value.pid,
            data: {},
        }
    }

    imageUrlUpdated = (event) => {       
        this.setState( {data: {...this.state.data, imageUrl: event.target.value}});
    }

    onValidSubmit = (event, values) => {
        const formData = new FormData(document.getElementById('mainForm'));
        packData(formData, this.state.data, values)
        formData.append("startDate", this.state.startDate)
        formData.append("endDate", this.state.endDate)        
        formData.append("startRegDate", this.state.startRegDate)
        formData.append("endRegDate", this.state.endRegDate)
        formData.append('menuJson', this.state.menuJson);
        formData.append('roomJson', this.state.roomJson);

        this.onSaveTournamentPage(formData);
    };

    onMenuJsonChanged = (event) => {
        this.state.menuJson = event.json;
    }

    onRoomJsonChanged = (event) => {
        this.state.roomJson = event.json;
    }

    onRoundJsonChanged = (event) => {
        this.state.roundJson = event.json;
    }

    onEventJsonChanged = (event) => {
        this.state.eventJson = event.json;
    }

    onStartDateChange = startDate => this.setState({ startDate })
    onEndDateChange = endDate => this.setState({ endDate })    
    onStartRegDateChange = startRegDate => this.setState({ startRegDate })
    onEndRegDateChange = endRegDate => this.setState({ endRegDate })
    
    onInvalidSubmit = (event, errors, values) => {
        this.setState({errors, values});
    };

    handleContentChange = (value) => {
        this.setState({
            data: { ...this.state.data, content: value }
        });
    }

    handleHookChange = (value) => {
        this.setState({
            data: { ...this.state.data, hook: value }
        });
    }

    onSaveTournamentPage = (values) => {
        updateObject('tournamentPage', values, this.state.pid).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({pid: d2.tournamentPage._id});
                this.loadTournamentPage();
            }
        });
    };

    loadTournamentPage = () => {
        this.setState({ loading: true});
        if (this.state.pid) {
            getObject('tournamentPage', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ 
                        data: d2.tournamentPage,
                        menuJson: d2.tournamentPage.menuJson, 
                        roomJson: d2.tournamentPage.roomJson, 
                        startDate: new Date(d2.tournamentPage.startDate ? d2.tournamentPage.startDate : null),
                        endDate: new Date(d2.tournamentPage.endDate ? d2.tournamentPage.endDate : null),
                        startRegDate: new Date(d2.tournamentPage.startRegDate ? d2.tournamentPage.startRegDate : null),
                        endRegDate: new Date(d2.tournamentPage.endRegDate ? d2.tournamentPage.endRegDate : null),
                        loading: false
                    });                    
                }
            });
        } else this.setState({ loading: false});
    };

    onSaveTournamentConfiguration(mode) {
        if (mode === 'events' && this.state.eventJson) {
            reviseTournamentPage(this.state.pid, JSON.stringify({events: JSON.parse(this.state.eventJson) }))
            .then(result => {
                alert('saved');
            });
        }
        if (mode === 'rounds' && this.state.roundJson) {
            reviseTournamentPage(this.state.pid, JSON.stringify({rounds: JSON.parse(this.state.roundJson) }))
            .then(result => {
                alert('saved');
            });
        }
    }

    componentDidMount() {
        this.loadTournamentPage();        
    }

    onGenerateTournament() {
        generateTournament(this.state.pid).then(d2 => {
            if (d2 && d2.error) {
                putToast.error(d2.error);
            } else {
                putToast.success(d2.message);                 
            }
        });
    }

    onGenerateWarning() {
        generateWarning(this.state.pid).then(d2 => {
            if (d2 && d2.error) {
                putToast.error(d2.error);
            } else {
                putToast.success(d2.message);                 
            }
        });
    }

    render() {
        const defaultValues = this.state.data;
        
        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       
        return (
            <Fragment>
                <Breadcrumb title="Edit TournamentPage" parents={[{name: "TournamentPage List", url: "/admin/tournamentPage/list"}]}/>
                
                <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={defaultValues}>
                    <FlowDataEntry >
                        <Fragment>                    
                            <AvField label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                            <AvField label="Notifications" grid={{xs: 10}} name="noticeCount" id="noticeCount" type="text" />
                            <AvField label="Guest Help Page Id" grid={{xs: 10}} name="guestHelpPageId" id="guestHelpPageId" type="text" />
                            <AvField label="Competitor Help Page Id" grid={{xs: 10}} name="competitorHelpPageId" id="competitorHelpPageId" type="text" />
                            <AvField label="Judge Help Page Id" grid={{xs: 10}} name="judgeHelpPageId" id="judgeHelpPageId" type="text" />
                            <AvField label="Admin Help Page Id" grid={{xs: 10}} name="adminHelpPageId" id="adminHelpPageId" type="text" />
                            <AvField label="Tags" grid={{xs: 10}} name="tags" id="tags" type="text" value={listItems(this.state.data.tags)}/>
                            <AvField label="Permissions" grid={{xs: 10}} name="permTags" id="permTags" type="text" value={listItems(this.state.data.permTags)}/>
                            <AvField label="Permissions Key" grid={{xs: 10}} name="permKey" id="permKey" type="text" />
                            <AvField label="Judge Rounds" grid={{xs: 10}} name="judgeRoundMin" id="judgeRoundMin" type="text" />
                            <AvField label="Status" grid={{xs: 10}} name="status" id="status" type="select">                                 
                                <option disabled value="">Select Status</option>                                 
                                <option value="draft" key="draft">Draft</option>     
                                <option value="private" key="private">Private</option>                                                             
                                <option value="publish" key="publish" >Publish</option>                                 
                                <option value="inactive" key="inactive" >Inactive</option>                                                        
                            </AvField>
                            <AvField label="Venue Type" grid={{xs: 10}} name="venueType" id="venueType" type="select">
                                <option disabled value="">Select Venue Type</option>
                                <option value="inperson" key="inperson">In Person</option>
                                <option value="online" key="online">Online</option>
                            </AvField>
                            <div className="row">
                                <div className="col-sm-2">
                                    Use Speech Timeslots
                                </div>
                                <div className="col-sm-10">
                                    <input type="hidden" name="useSpeechTimeSlots" value="false" />
                                    <AvField name="useSpeechTimeSlots" id="useSpeechTimeSlots" type="checkbox" checked={!!this.state.data.useSpeechTimeSlots} onChange={(e) => this.setState({ data: { ...this.state.data, useSpeechTimeSlots: e.target.checked }})} />
                                </div>
                            </div>
                        </Fragment>

                        <Editor 
                            content={defaultValues.content}
                            onContentChange={this.handleContentChange}
                        />

                        <Fragment> 
                        <div className="row">
                                <div className="col-sm-2">
                                    Registration Start Date
                                </div>
                                <div className="col-sm-10">  
                                    <DateTimePicker
                                        onChange={this.onStartRegDateChange}
                                        value={this.state.startRegDate}
                                        disableClock
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-sm-2">
                                    Registration End Date
                                </div>
                                <div className="col-sm-10">  
                                    <DateTimePicker
                                        onChange={this.onEndRegDateChange}
                                        value={this.state.endRegDate}
                                        disableClock
                                    />
                                </div>
                            </div>
                            <br />                                               
                            <div className="row">
                                <div className="col-sm-2">
                                    Start Date
                                </div>
                                <div className="col-sm-10">  
                                    <DateTimePicker
                                        onChange={this.onStartDateChange}
                                        value={this.state.startDate}
                                        disableClock
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-sm-2">
                                    End Date
                                </div>
                                <div className="col-sm-10">  
                                    <DateTimePicker
                                        onChange={this.onEndDateChange}
                                        value={this.state.endDate}
                                        disableClock
                                    />
                                </div>
                            </div>
                        </Fragment>

                        <Fragment>                    
                            <AvField label="Image Url" grid={{xs: 10}} name="imageUrl" id="imageUrl" type="text" onBlur={(e) => this.imageUrlUpdated(e)}/>
                            <div className="row">
                                <div className="col-sm-2">
                                </div>
                                <div className="col-sm-10">  
                                    <img src={defaultValues.imageUrl}  style={{border:"1px solid #021a40", height:200}} alt="" />
                                </div>
                            </div>
                        </Fragment>

                        <Fragment>                    
                            <div className="row">
                                <div className="col-sm-2"> Definition<br/><br/>
                                <button type="button" className="btn btn-primary" onClick={() => this.onGenerateTournament()}>Generate</button><br/><br />
                                <button type="button" className="btn btn-primary" onClick={() => this.onGenerateWarning()}>Warning</button>
                                </div>
                                <div className="col-sm-10">  
                                    <JSONInput
                                        id          = 'a_unique_id'
                                        locale      = { locale }
                                        height      = '550px'
                                        width       = '100%'
                                        placeholder = { this.state.menuJson? JSON.parse(this.state.menuJson) : [  { name: 'Home', link: '/' } ] }
                                        onChange = {this.onMenuJsonChanged}
                                    />
                                </div>
                            </div>
                        </Fragment> 

                        <Fragment>                    
                            <div className="row">
                                <div className="col-sm-2"> Video Rooms<br/><br/>
                                <button type="button" className="btn btn-primary" >Create Rooms</button>
                                </div>
                                <div className="col-sm-10">  
                                    <JSONInput
                                        id          = 'a_unique_id'
                                        locale      = { locale }
                                        height      = '550px'
                                        width       = '100%'
                                        placeholder = { this.state.roomJson? JSON.parse(this.state.roomJson) : [  { title: 'Home', permissions: '', link: '/' } ] }
                                        onChange = {this.onRoomJsonChanged}
                                    />
                                </div>
                            </div>
                        </Fragment> 

                        <Fragment>                    
                            <div className="row">
                                <div className="col-sm-2"> Events Config<br/><br/>
                                <button type="button" className="btn btn-primary" onClick={() => this.onSaveTournamentConfiguration('events')}>Save</button><br/><br />
                                </div>
                                <div className="col-sm-10">  
                                    <JSONInput
                                        id          = 'a_unique_id'
                                        locale      = { locale }
                                        height      = '550px'
                                        width       = '100%'
                                        placeholder = { this.state.data.events ? this.state.data.events  : [  { name: 'Home', link: '/' } ] }
                                        onChange = {this.onEventJsonChanged}
                                    />
                                </div>
                            </div>
                        </Fragment>
                        <Fragment>                    
                            <div className="row">
                                <div className="col-sm-2"> Round Config<br/><br/>
                                <button type="button" className="btn btn-primary" onClick={() => this.onSaveTournamentConfiguration('rounds')}>Save</button><br/><br />
                                </div>
                                <div className="col-sm-10">  
                                    <JSONInput
                                        id          = 'a_unique_id'
                                        locale      = { locale }
                                        height      = '550px'
                                        width       = '100%'
                                        placeholder = { this.state.data.rounds ? this.state.data.rounds  : [  { name: 'Home', link: '/' } ] }
                                        onChange = {this.onRoundJsonChanged}
                                    />
                                </div>
                            </div>
                        </Fragment> 
                    </FlowDataEntry >
                </AvForm>   
            </Fragment>
        )
    }
}
}

export default TournamentPageEdit
